import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import WorkerPutAwayAnalysisReportActions from '../../Stores/WorkerPutAwayAnalysisReport/Actions';

const { Panel } = Collapse;

class WorkerPutAwayAnalysisReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initWorkerPutAwayAnalysis } = this.props;

    if (curSiteFlowId > 0) {
      initWorkerPutAwayAnalysis();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initWorkerPutAwayAnalysis } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initWorkerPutAwayAnalysis();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'worker_put_away_analysis_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

WorkerPutAwayAnalysisReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initWorkerPutAwayAnalysis: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

WorkerPutAwayAnalysisReportScreen.defaultProps = {
  intl: {},
  match: {},

  initWorkerPutAwayAnalysis: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initWorkerPutAwayAnalysis: () =>
    dispatch(
      WorkerPutAwayAnalysisReportActions.workerPutAwayAnalysisReportInitWorkerPutAwayAnalysis()
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(WorkerPutAwayAnalysisReportScreen));
